




























































import { Component, Prop, Vue } from 'vue-property-decorator';
import { signIn, signOut, signedIn, authManager} from '../utils/login';
import { UserService } from "@/services/user-service";
import { User } from '@/model/user';
import * as Constants from '@/utils/constants';

@Component
export default class UserList extends Vue {
    // data
    error: any = null;
    loading: boolean = false;
    showDismissibleAlert: boolean = false;
    currentPage: number = 1;
    perPage: number = 10;
    pageOptions: Array<number> = [ 10, 25, 50 ];
    sortBy: any = null;
    sortDesc: any = false;
    filter: any = null;
    users: Array<User> = [];
    private fields: object[] = [
        { key: 'name', label: 'Nome', sortable: true },
        { key: 'surname', label: 'Cognome', sortable: true},
        { key: 'email', label: 'Email', sortable: true},
        { key: 'points', label: 'Punti', sortable: true},
        { key: 'shortCode', label: 'Codice Utente', class: 'uppercase', sortable: true},
        { key: 'edit', label: ''},
        // { key: "delete", label: ""},
    ];

    userListService: UserService = new UserService();

    token: string = "";

    // methods
    private getUsersList() {
        this.userListService.getAllUsers(this.token).then((users: any) => {
            this.users = users;
        });
    }

    dowloadUserList() {
         this.userListService.downloadlUserList(this.token);
    }

    @Prop()
    user: any;

    // computed
    get totalUsers() {
        return this.users ? this.users.length : 0;
    }

    get longUserList() {
        return this.users && this.users.length > 10
    }

    get isSignedIn() {
      return this.user !== null;
    }

    get isAdmin() {
      return this.user.profile.roles.indexOf(Constants.ADMIN_ROLE) > -1;
    }

    created() {
        this.token = this.user.access_token;
        this.getUsersList();
    }
}

